import FormatProcessor from './FormatProcessor'

/**
 * parseQrType – Determine the type of scanned QR code
 *
 * Supported formats:
 *   PM-Inventory : starts with "PM-INV|" prefix via FormatProcessor
 *   Inventory QR : starts with "INV:" prefix  →  { type: 'inventory', value: '<id>' }
 *   Carrier  QR  : starts with "CAR:" prefix  →  { type: 'carrier',   value: '<code>' }
 *   SKU-based    : any other non-empty string  →  { type: 'sku',       value: '<raw>' }
 *   Unknown      : empty / whitespace          →  { type: 'unknown',   value: '' }
 *
 * The prefix convention can be adjusted once real QR samples are provided.
 *
 * @param {string} scannedString – raw string from scanner
 * @returns {{ type: 'inventory'|'carrier'|'sku'|'command'|'PM-Inventory'|'unknown', value: string, ... }}
 */
export const parseQrType = (scannedString) => {
  if (!scannedString || typeof scannedString !== 'string') {
    return { type: 'unknown', value: '' }
  }

  const trimmed = scannedString.trim()

  if (trimmed.length === 0) {
    return { type: 'unknown', value: '' }
  }

  // 1. Specialized PasarMIKRO Formats (PM-Inventory, format=command, etc.)
  const pmData = FormatProcessor.parse(trimmed)
  if (pmData) {
    return { ...pmData, value: trimmed }
  }

  // 2. Inventory QR with explicit prefix
  if (trimmed.toUpperCase().startsWith('INV:')) {
    return { type: 'inventory', value: trimmed.substring(4).trim() }
  }

  // 3. Carrier QR with explicit prefix
  if (trimmed.toUpperCase().startsWith('CAR:')) {
    return { type: 'carrier', value: trimmed.substring(4).trim() }
  }

  // Fallback: treat as SKU / general code lookup
  return { type: 'sku', value: trimmed }
}


export default parseQrType

